import { render, staticRenderFns } from "./PopupType1.vue?vue&type=template&id=4ca2caf2&"
import script from "./PopupType1.vue?vue&type=script&lang=js&"
export * from "./PopupType1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports